import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;
 
export const insertAmenity = (data) => {
  return axios.post(`${CoreService.getPrivateURL()}amenities`, data, {withCredentials:true});
};

export const updateAmenity = (id, data) => {
  return axios.put(`${CoreService.getPrivateURL()}amenities/${id}`, data, { withCredentials: true });
};

export const deleteAmenity = (amenityId) => {
  return axios.delete(`${CoreService.getPrivateURL()}amenities/`  +amenityId,{withCredentials:true});
};

export const uploadImage = (form_data) => {
  return axios.post(`${CoreService.getPrivateURL()}amenities/images`, form_data, {withCredentials:true,
    headers:{
    'Content-Type':'multipart/form-data'
    }});
};

export const getAmenities = (filter) => {
  console.log("Filter in request is " + filter)
  return axios.get(`${CoreService.getPrivateURL()}amenities?filter=${filter}`);
};

export const getAmenitiesType = () => {
  return axios.get(`${CoreService.getPrivateURL()}amenities/types`);
};

export const deleteAmenitiesType = (amenityType) => {
  return axios.delete(`${CoreService.getPrivateURL()}amenities/types/${amenityType}` );
};

export const insertAmenityType = (parent_id, amenity_type) => {
  return axios.post(`${CoreService.getPrivateURL()}amenities/types`, {parent_id, amenity_type}, {withCredentials:true} );
};

export const removeAmenityType = (parent_id) => {
  return axios.delete(`${CoreService.getPrivateURL()}amenities/types/${parent_id.toString()}` );
};

const buildDebugNowQuery = (debugNow) => {
  return debugNow ? `?debug_now=${encodeURIComponent(debugNow)}` : "";
};

export const getAmenityInfoCustomUser = (id, userid, debugNow = "") => {
  return axios.get(`${CoreService.getPrivateURL()}amenities/${id.toString()}/${userid.toString()}${buildDebugNowQuery(debugNow)}` );
};

export const getAmenityInfo = (id, debugNow = "") => {
  return axios.get(`${CoreService.getPrivateURL()}amenities/${id.toString()}${buildDebugNowQuery(debugNow)}` );
};

export const getAmenitySharedResources = () => {
  return axios.get(`${CoreService.getPrivateURL()}amenities/shared-resources`, {withCredentials:true});
};

export const getAmenityBookingLimitGroups = () => {
  return axios.get(`${CoreService.getPrivateURL()}amenities/booking-limit-groups`, {withCredentials:true});
};

export const createAmenityBookingLimitGroup = (data) => {
  return axios.post(`${CoreService.getPrivateURL()}amenities/booking-limit-groups`, data, {withCredentials:true});
};

export const updateAmenityBookingLimitGroup = (id, data) => {
  return axios.put(`${CoreService.getPrivateURL()}amenities/booking-limit-groups/${id}`, data, {withCredentials:true});
};

export const getAmenityResourceLayouts = () => {
  return axios.get(`${CoreService.getPrivateURL()}amenities/resource-layouts`, {withCredentials:true});
};

export const createBooking = (id, booking_data) => {
  return axios.post(`${CoreService.getPrivateURL()}booking/amenities/${id.toString()}${buildDebugNowQuery(booking_data?.debug_now || "")}` , booking_data,
      {withCredentials:true});
};

export const searchBookingMembers = (amenityId, buildingId, query = "") => {
  return axios.get(
    `${CoreService.getPrivateURL()}booking/amenities/${amenityId.toString()}/members?building_id=${buildingId || ""}&q=${encodeURIComponent(query || "")}`,
    {withCredentials:true}
  );
};

export const getBookings = (start, end, status) => {
  return axios.get(`${CoreService.getPrivateURL()}bookings/?start=${start}&end=${end}&status=${status}`, {withCredentials:true});
};

export const cancelBooking = (id, cancellationMessage = "") => {
  return axios.delete(`${CoreService.getPrivateURL()}bookings/${id.toString()}` , {
    withCredentials:true,
    data: { cancellation_message: cancellationMessage },
  });
};

export const getMemberDashboard = () => {
  return axios.get(`${CoreService.getPrivateURL()}member_dashboard`, {withCredentials:true});
};

export const getQuestions = () => {
  return axios.get(`${CoreService.getPrivateURL()}amenities/questions`);
};

const AmenitiesService = {
  insertAmenity,
  updateAmenity,
  uploadImage,
  deleteAmenity,
  getAmenities,
  getAmenitiesType,
  deleteAmenitiesType,
  insertAmenityType,
  removeAmenityType,
  getAmenityInfo,
  getAmenitySharedResources,
  getAmenityBookingLimitGroups,
  createAmenityBookingLimitGroup,
  updateAmenityBookingLimitGroup,
  getAmenityResourceLayouts,
  getAmenityInfoCustomUser,
  createBooking,
  searchBookingMembers,
  getBookings,
  cancelBooking,
  getMemberDashboard,
  getQuestions
};


export default AmenitiesService;
